<template>
  <div>
    <DataTable
      :value="holidays"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :loading="loading"
      sortField="holidayDate"
      :sortOrder="1"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} bank holidays"
    >
      <template #empty> No bank holidays found. </template>
      <template #loading> Loading bank holidays. Please wait. </template>
      <Column field="holidayDate" header="Date" headerStyle="width: 9em" :sortable="true">
        <template #body="slotProps">{{ displayDate(slotProps.data.holidayDate) }}</template>
      </Column>
      <Column field="name" header="Name" :sortable="true" />
      <Column headerStyle="width: 8em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-info"
              class="p-button-success p-mb-2"
              @click="$emit('edit-holiday', slotProps.data)"
              :model="getButtons(slotProps.data)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import PermissionMixin from '../../PermissionMixin.vue'
import { displayDate } from './bankHolidayDates'

export default {
  mixins: [PermissionMixin],
  props: ['holidays', 'loading'],
  methods: {
    displayDate,
    getButtons(data) {
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push({
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.$emit('delete-holiday', data)
          }
        })
      }
      return buttons
    }
  }
}
</script>

<style></style>
